import type { ButtonHTMLAttributes } from 'react'
import { cn } from '@/shared/lib'
import { Icon, type IconName } from '@/shared/ui/icon'

type Variant = 'solid' | 'outline' | 'accent' | 'raise'
type Size = 'md' | 'sm'

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName
  'aria-label': string
  variant?: Variant
  size?: Size
}

const variants: Record<Variant, string> = {
  solid: 'bg-card text-app-fg hover:bg-hover',
  raise: 'bg-raise text-app-fg hover:bg-hover',
  outline: 'border border-outline text-app-fg hover:bg-raise',
  accent: 'bg-accent text-accent-fg hover:opacity-90',
}

const sizes: Record<Size, { box: string; icon: number }> = {
  md: { box: 'size-11', icon: 20 },
  sm: { box: 'size-9', icon: 17 },
}

export function IconButton({
  icon,
  variant = 'solid',
  size = 'md',
  className,
  type,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type ?? 'button'}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-control transition-colors disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        sizes[size].box,
        className,
      )}
      {...rest}
    >
      <Icon name={icon} size={sizes[size].icon} />
    </button>
  )
}
